import { useInfiniteQuery } from "@tanstack/react-query";
import { auditService } from "@/lib/api/services/audit.service";
import type { AuditListFilter } from "@/types/audit-log.types";

const PAGE_SIZE = 30;

interface ResourceAuditParams {
  resourceType: string;
  resourceId: string;
  filter?: Omit<AuditListFilter, "resourceType" | "resourceId" | "page" | "limit">;
  enabled?: boolean;
  limit?: number;
}

export function useResourceAuditQuery({
  resourceType,
  resourceId,
  filter = {},
  enabled = true,
  limit = PAGE_SIZE,
}: ResourceAuditParams) {
  return useInfiniteQuery({
    queryKey: ["resource-activity", "audit", resourceType, resourceId, filter, limit],
    queryFn: ({ pageParam = 1 }) =>
      auditService.listResourceEntries({
        ...filter,
        resourceType: [resourceType],
        resourceId,
        page: pageParam as number,
        limit,
      }),
    getNextPageParam: (lastPage) => lastPage.nextPage ?? undefined,
    initialPageParam: 1,
    enabled: enabled && Boolean(resourceType && resourceId),
    staleTime: 0,
    refetchOnMount: "always",
  });
}
